import React from 'react'

import GroupList from '../../components/pages/groupList'

const ItemGroups = () => <GroupList purpose="item" />

export default ItemGroups
